import React from 'react';

const PhoneIcon: React.FC = () => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2501 12.6901V14.9401C16.2518 15.3624 16.0754 15.7659 15.7641 16.0515C15.4529 16.337 15.0357 16.4781 14.6151 16.4401C12.3072 16.1893 10.0903 15.4007 8.14258 14.1376C6.33045 12.9861 4.79408 11.4497 3.64258 9.63757C2.37506 7.68098 1.58626 5.45332 1.34008 3.13507C1.30218 2.71573 1.44228 2.29976 1.72615 1.98879C2.01002 1.67782 2.41152 1.50047 2.83258 1.50007H5.08258C5.83548 1.49266 6.4772 2.04455 6.58258 2.79007C6.67754 3.51012 6.85366 4.21712 7.10758 4.89757C7.31363 5.44573 7.18184 6.06368 6.77008 6.48007L5.81758 7.43257C6.88524 9.31023 8.43992 10.8649 10.3176 11.9326L11.2701 10.9801C11.6865 10.5683 12.3044 10.4365 12.8526 10.6426C13.533 10.8965 14.24 11.0726 14.9601 11.1676C15.7142 11.274 16.269 11.9287 16.2501 12.6901Z"
      stroke="#171D23"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PhoneIcon;
